import React from "react";

const Worker = () => {
      
  return(
    <h2>Worker</h2>
  )
}

export default Worker;